import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';

export const ManagementSectionContainer = styled(FlexibleDiv)`
  gap: 15px;
  margin-bottom: 15px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 10px;
  }
`;

export const buttonStyles = css`
  > span {
    border: none;
  }
`;
